import baseApi from "../../../Lib/api/baseApi";
import endpoints from "../../../Lib/api/endpoints";

export const CustomerApi = baseApi.injectEndpoints({
  tagTypes: ["Customer"],
  endpoints: (builder) => ({
    getAllCustomers: builder.query({
      query: (data) => ({
        ...endpoints.getAllCustomers(data),
      }),
      transformResponse: (response) => {
        const transformedData = response?.data?.data?.map((d, index) => ({
          no: index + 1,
          name: `${d?.firstName} ${d?.lastName}`,
          email: d?.email,
          phoneNumber: d?.phoneNumber,
          gender: d?.gender || "",
          emailVerified: d?.emailVerified,
          activated: d?.activated,
          id: d?.id,
          createdAt: d?.createdAt,
        }));
        return {
          data: transformedData,
          page: response?.data?.page || 0,
          total: response?.data?.total || 0,
          limit: response?.data?.limit || 0,
        };
      },
      providesTags: [{ type: "Customer", id: "All" }],
    }),
    getCustomerStats: builder.query({
      query: () => ({
        ...endpoints.getCustomerStats,
      }),
      providesTags: [{ type: "Customer", id: "Stats" }],
    }),
    getCustomerById: builder.query({
      query: (id) => ({
        ...endpoints.getCustomerById(id),
      }),
      providesTags: [{ type: "Customer", id: "Single" }],
    }),
    deactivateCustomer: builder.mutation({
      query: (id) => ({
        ...endpoints.deactivateCustomer(id),
      }),
      invalidatesTags: [
        { type: "Customer", id: "All" },
        { type: "Customer", id: "Single" },
        { type: "Customer", id: "Stats" },
      ],
    }),
    reactivateCustomer: builder.mutation({
      query: (id) => ({
        ...endpoints.reactivateCustomer(id),
      }),
      invalidatesTags: [
        { type: "Customer", id: "All" },
        { type: "Customer", id: "Single" },
        { type: "Customer", id: "Stats" },
      ],
    }),
  }),
});

export const {
  useGetAllCustomersQuery,
  useGetCustomerStatsQuery,
  useGetCustomerByIdQuery,
  useDeactivateCustomerMutation,
  useReactivateCustomerMutation,
} = CustomerApi;
